import styled from "styled-components";
import { images } from "../../constants";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 100vh;
  width: 100%;
  color: var(--primary);
  background-color: var(--secondary);
`;

export const Banner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  background-color: var(--darkBlue);

  @media (max-width: 900px) {
    flex-direction: column;
    height: 40rem;
    justify-content: center;
    align-items: center;
      width: 100%;
  }
  
  @media (max-width: 600px) {
    flex-direction: column;
    height: 35rem;
    justify-content: center;
    align-items: center;
    width: 100%;
  }  
`;

export const IconBanner = styled.div`
  display: flex;
  background-color: var(--hardYellow);
  background-image: url(${images.fundobanner}) ;
  background-repeat: repeat;
  margin: 15rem 0 5rem 0;
  width: 79%;
  justify-content: right;
  border-radius: 0 7rem 7rem 0;
  box-shadow: 0.3rem 0.3rem 0.3rem var(--primary);
  
  @media (max-width: 900px) {
    width: 100%;
    border-radius: 0;
    justify-content: center;
    align-items: center;
    /* margin: 10rem 0; */
  }
`;

export const ViewGalery = styled.div`
display: flex;
width: 70rem;
align-items: center;
justify-content: center;

  @media (max-width: 1300px) {
    margin: 0;
    width: 50rem;
  }

    @media (max-width: 900px) {
    margin: 0;
    width: 60rem;
  }

`;

export const ViewImages = styled.div`
display: flex;
width: 100%;


@media (max-width: 900px) {
  width: 100%;
  }
`;

export const ImgBanner = styled.img`
  display: flex;
  width: 21rem;
  height:25rem;
  margin: 0 5rem 0 5rem;

  @media (max-width: 1300px) {
    margin: 0 5rem 0 2rem;
  }

  @media (max-width: 900px) {
    width: 19rem;
    height:23rem;
    margin: 0 2rem 0 2rem;
    margin-right: 0;
  }

  @media (max-width: 600px) {
    width: 12rem;
    height:14rem;
    margin: 0 1rem 0 1rem;
    margin-right: 0;
  }
`;

export const Centro = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 18rem;
  gap: 0.5rem;
  padding-left: 21%;
  
  @media (max-width: 865px) {
  flex-direction: column;
  height: 39rem;
  gap: 0;
  } 
`;

export const Description = styled.div`
  display: flex;
  width: 35rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: justify;
  line-height: calc(var(--size) * 3.5);
  font-family: var(--familyTitle);
  font-weight: bold;
  font-size: calc(var(--size) * 1.6);
  color: var(--darkBlue);
  border-radius: 3rem;
  background-color: var(--softGray);
  padding: 2rem;
  height: 15rem;
  box-shadow: 0.3rem 0.3rem 0.3rem var(--darkBlue);
  margin: 1rem;
  
  :hover {
    /* color: var(--purple); */
    background-color: var(--hardYellow);
    transform: scale(0.95);
  }

  @media (max-width: 1095px) {
    width: 26rem;
    /* font-size: calc(var(--size) * 1.4); */
  }

  @media (max-width: 850px) {
    width: 26rem;
    margin: 0.5rem;
    height: 12rem;
  }

  
`;

export const Icon = styled.img`
  display: flex;
  width: 6rem;
  margin: 1rem;
`;

export const Description2 = styled.div`
  width: 35rem;
  max-width: 118rem;
  /* margin: 0 auto 2rem auto; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* flex-wrap: nowrap; */
  text-align: justify;
  line-height: calc(var(--size) * 3.5);
  font-family: var(--familyTitle);
  font-weight: bold;
  font-size: calc(var(--size) * 1.6);
  color: var(--secondary);
  /* border: 3px solid; */
  border-radius: 3rem;
  background-color: var(--softBlue);
  padding: 3rem;
  height: 15rem;
  box-shadow: 0.3rem 0.3rem 0.3rem var(--darkBlue);
  height: 15rem;

  :hover {
    transform: scale(0.95);
    /* color: var(--purple); */
    /* font-weight: bold; */
    background-color: var(--hardYellow);
  }

  @media (max-width: 1095px) {
    width: 26rem;
  }
  
  @media (max-width: 850px) {
    width: 26rem;
    margin: 0.5rem;
    height: 12rem;

  }
`;

export const Link = styled.a`
  display: flex;
  transition: transform 0.3s;
  cursor: pointer;
  font-size: calc(var(--size) * 1.5);
  /* font: var(--body); */
  outline: none;
  text-decoration: none;
  color: var(--primary);  
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 1rem 0;

  > div {
    width: 100%;
    max-width: 10rem;
  }
`;